<template>
    <div class="j-no-records-root">
        <p class="j-title">
            <slot>{{ $t(text) }}</slot>
        </p>
    </div>
</template>

<script setup>
const props     = defineProps({
    text        : {
        type        : String,
        default     : "common.no-records",
    }
})
</script>